
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"door-plus"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.214 9.184a.265.265 0 01-.26-.27c0-.149.116-.27.26-.27m.001.54c.144 0 .26-.12.26-.27a.265.265 0 00-.26-.27","stroke":"currentColor","stroke-width":"1.25"}}),_c('path',{attrs:{"d":"M10.164 2.418h3.125c.276 0 .54.114.736.316a1.1 1.1 0 01.305.763v2.504M8.08 8.912V1.356a.557.557 0 00-.195-.419.514.514 0 00-.437-.106l-6.25 1.597a.518.518 0 00-.291.186.552.552 0 00-.118.332v12.615a.552.552 0 00.125.356.51.51 0 00.32.184l3.124.446 1.562.223.782.112M14 11.5v5M11.5 14h5M9 14a5 5 0 1010 0 5 5 0 00-10 0z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    